<template>
  <guest-layout>
    <!-- Header Banner -->
    <template #header>
      <font-awesome-icon icon="fas fa-circle-exclamation" />
      Bagi mahasiswa yang telah mengajukan permohonan, agar segera login untuk mengecek status permohonannya
    </template>

    <!-- Title -->
    <Head title="Login" />

    <!-- Container -->
    <div class="container p-6 mx-auto my-6 max-w-8xl">
      <div class="flex flex-wrap justify-between bg-white rounded-lg shadow-xl md:flex">
        <!-- Left Section (Image & Daftar) -->
        <div class="relative flex-col hidden w-0 rounded-tr-lg rounded-br-lg md:flex md:w-6/12 lg:w-7/12">
          <img
            src="/images/background.png"
            alt="Background"
            class="flex-1 object-cover"
          />
        </div>

        <!-- Right Section (Form) -->
        <div class="w-full md:w-6/12 lg:w-5/12">
          <form class="mt-8 overflow-hidden bg-white" @submit.prevent="login">
            <div class="px-10 py-4">
              <h1 class="text-2xl font-bold text-center">Login</h1>
              <div class="w-24 mx-auto mt-6 border-b-2" />

              <!-- Username -->
              <text-input
                id="username"
                v-model="form.username"
                :error="form.errors.username"
                class="mt-10"
                label="User ID"
                type="text"
                autofocus
                autocapitalize="off"
              />

              <!-- Password -->
              <text-input
                id="password"
                v-model="form.password"
                :error="form.errors.password"
                class="mt-6"
                label="Password"
                type="password"
              />
              <!-- Forgot Password Link -->
              <div v-if="!isReadOnly()" class="mt-2 text-right">
                <Link href="/forgot-password" class="text-sm text-blue-600 hover:underline">
                  Lupa Password?
                </Link>
              </div>

              <!-- Remember Me -->
              <label for="remember" class="flex items-center mt-6 select-none">
                <input
                  id="remember"
                  v-model="form.remember"
                  type="checkbox"
                  class="mr-1"
                />
                <span class="text-sm">Remember Me</span>
              </label>

              <!-- Submit -->
              <loading-button
                :loading="form.processing"
                class="mt-6 btn-green"
                type="submit"
              >
                <font-awesome-icon icon="fas fa-key" />
                &nbsp;Login
              </loading-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </guest-layout>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import GuestLayout from '@/Layouts/GuestLayout.vue'

export default {
  components: {
    Head,
    Link,
    TextInput,
    LoadingButton,
    GuestLayout,
  },
  data() {
    return {
      form: this.$inertia.form({
        username: '',
        password: '',
        remember: false,
      }),
    }
  },
  methods: {
    login() {
      this.form.post('/login')
    },
  },
}
</script>
